module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"support_ticket_delete_button":{"title":"Deletar","message":{"title":"Delete support ticket(s)","message":"Deseja deletear a(s) tickets(s)?"}}},"en":{"support_ticket_delete_button":{"title":"Delete","message":{"title":"Delete support ticket(s)","message":"Do you want to delete the ticket(s)"}}}}')
  delete Component.options._Ctor
}
